import { Theme, nuOrderTheme as theme } from "@nuorder/components";
import { merge, $ } from "glamor";
import * as React from "react";
import { ShowDoorLabelIconContainer as ShowDoorLabelMenuIcon } from "./door-label-Icon";
import { EditAssortmentDialogIconContainer as EditAssortmentDialogIcon } from "./edit-assortment";

export const DoorsTabToolbar = () => {
    return (
        <StyleWrapper>
            <ShowDoorLabelMenuIcon />
            <EditAssortmentDialogIcon />
        </StyleWrapper>
    );
};

const styles = merge(
    $(".toolbar", {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        padding: "0 10px",
        marginTop: "8px",
    }),
    $(" .item svg ", {
        fill: theme.palette.greyDarker,
        color: theme.palette.greyDarker,
    }),
    $(" .item-tag i ", {
        transform: "scale(2)",
        color: theme.palette.greyDarker,
        fontWeight: "400",
        margin: "8px 14px 0 0",
    })
);

type StyleWrapperProps = {
    children: React.ReactNode;
};
const StyleWrapper = ({ children }: StyleWrapperProps) => (
    <Theme>
        <div {...styles} className="toolbar">
            {children}
        </div>
    </Theme>
);
